// export interface StaticMapAsset extends IAsset {
//     // key: string;
//     type: "APPLICATION/MAP";
//     target: {
//         location: LngLat;
//         size: ISize;
//         //缩放
//         zoom?: number;
//     };
// }

export function isBundleAsset(asset) {
  return asset.type === 'bundle';
}